import { useAuthStore } from 'store/useAuthStore'

export const handleUnauthorized = () => {
    const authStore = useAuthStore.getState()
    const isTutor = authStore.userInfo?.isTutor
    authStore.reset()
    window.location.replace(isTutor ? '/tutor-login' : '/login')
}
